<template>
  <span style="white-space: nowrap">
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 511.351 511.351" style="enable-background:new 0 0 511.351 511.351;" xml:space="preserve"
      :width="width" :height="height">
      <g>
        <g>
          <path style="fill:#E9001E;" d="M241.005,338.937c1.664-2.516,4.555-3.875,7.625-3.531l138.562,16.648
            c2.5,0.305,4.719,1.766,5.977,3.945l50.43,87.352c1.344,2.328,1.43,5.18,0.227,7.578c-1.203,2.406-3.539,4.047-6.211,4.367
            l-57.086,6.812l-34.445,46.031c-1.516,2.031-3.891,3.211-6.406,3.211c-0.156,0-0.32-0.008-0.484-0.016
            c-2.688-0.164-5.109-1.664-6.453-4l-92-160C239.231,344.719,239.333,341.461,241.005,338.937z"/>
        </g>
        <g>
          <path style="fill:#FF4F19;" d="M323.746,363.336c-1.508-2.617-1.406-5.875,0.266-8.398c1.664-2.516,4.555-3.875,7.625-3.531
            l63.27,7.602l48.693,84.343c1.344,2.328,1.43,5.18,0.227,7.578c-1.203,2.406-3.539,4.047-6.211,4.367l-57.075,6.811
            L323.746,363.336z"/>
        </g>
        <g>
          <path style="fill:#FF4F19;" d="M270.348,338.937c-1.664-2.516-4.555-3.875-7.625-3.531L124.16,352.055
            c-2.5,0.305-4.719,1.766-5.977,3.945l-50.43,87.352c-1.344,2.328-1.43,5.18-0.227,7.578c1.203,2.406,3.539,4.047,6.211,4.367
            l57.086,6.812l34.445,46.031c1.516,2.031,3.891,3.211,6.406,3.211c0.156,0,0.32-0.008,0.484-0.016
            c2.688-0.164,5.109-1.664,6.453-4l92-160C272.121,344.719,272.019,341.461,270.348,338.937z"/>
        </g>
        <g>
          <path style="fill:#E9001E;" d="M187.607,363.336c1.508-2.617,1.406-5.875-0.266-8.398c-1.664-2.516-4.555-3.875-7.625-3.531
            l-63.27,7.602l-48.693,84.343c-1.344,2.328-1.43,5.18-0.227,7.578c1.203,2.406,3.539,4.047,6.211,4.367l57.075,6.811
            L187.607,363.336z"/>
        </g>
        <g>
          <path style="fill:#FFD200;" d="M437.238,163.875c-8.109-8.062-15.781-15.68-18.914-23.234c-3.367-8.109-3.391-19.82-3.414-31.148
            C414.863,91.547,414.824,73,402.754,60.93c-12.07-12.078-30.625-12.117-48.562-12.164c-11.328-0.023-23.039-0.055-31.148-3.414
            c-7.562-3.133-15.18-10.805-23.242-18.922C287.496,14.039,273.551,0,255.676,0s-31.82,14.039-44.125,26.43
            c-8.062,8.117-15.68,15.789-23.242,18.922c-8.109,3.367-19.82,3.391-31.148,3.414c-17.937,0.047-36.484,0.086-48.562,12.156
            C96.527,73,96.488,91.547,96.441,109.484c-0.023,11.328-0.047,23.039-3.414,31.148c-3.141,7.562-10.805,15.18-18.922,23.242
            c-12.391,12.305-26.43,26.25-26.43,44.125c0,17.883,14.039,31.828,26.43,44.133c8.117,8.062,15.789,15.672,18.922,23.234
            c3.367,8.109,3.391,19.82,3.414,31.148c0.047,17.945,0.086,36.492,12.156,48.562c12.07,12.078,30.625,12.117,48.57,12.156
            c11.328,0.031,23.031,0.055,31.141,3.414c7.562,3.141,15.18,10.805,23.242,18.922c12.305,12.391,26.25,26.43,44.125,26.43
            s31.82-14.039,44.125-26.43c8.062-8.117,15.68-15.781,23.242-18.922c8.102-3.359,19.812-3.383,31.133-3.414
            c17.945-0.039,36.5-0.078,48.578-12.156c12.07-12.07,12.109-30.617,12.156-48.562c0.023-11.328,0.047-23.039,3.414-31.148
            c3.133-7.562,10.805-15.172,18.922-23.234c12.391-12.305,26.43-26.25,26.43-44.133
            C463.676,190.125,449.629,176.18,437.238,163.875z"/>
        </g>
        <g>
          <path style="fill:#FF9600;" d="M93.027,140.633c-3.141,7.562-10.805,15.18-18.922,23.242c-12.391,12.305-26.43,26.25-26.43,44.125
            c0,17.883,14.039,31.828,26.43,44.133c8.117,8.062,15.789,15.672,18.922,23.234c3.367,8.109,3.391,19.82,3.414,31.148
            c0.047,17.945,0.086,36.492,12.156,48.562c12.07,12.078,30.625,12.117,48.57,12.156c11.328,0.031,23.031,0.055,31.141,3.414
            c7.562,3.141,15.18,10.805,23.242,18.922c12.305,12.391,26.25,26.43,44.125,26.43s31.82-14.039,44.125-26.43
            c8.062-8.117,15.68-15.781,23.242-18.922c8.102-3.359,19.812-3.383,31.133-3.414c17.945-0.039,36.5-0.078,48.578-12.156
            L108.598,60.922C96.527,73,96.488,91.547,96.441,109.484C96.418,120.812,96.394,132.523,93.027,140.633z"/>
        </g>
        <g>
          <circle style="fill:#FFFFFF;" cx="255.676" cy="208.003" r="136.651"/>
        </g>
        <g>
          <path style="fill:#FF9600;" d="M335.181,286.857l-158.36-158.36c-20.46,20.293-33.145,48.412-33.145,79.506
            c0,61.856,50.144,112,112,112C286.769,320.003,314.888,307.317,335.181,286.857z"/>
        </g>
        <g>
          <path style="fill:#FFD200;" d="M159.39,111.065c-24.921,24.754-40.365,59.037-40.365,96.937
            c0,75.47,61.181,136.651,136.651,136.651c37.901,0,72.183-15.445,96.937-40.366L159.39,111.065z"/>
        </g>
        <g>
          <circle style="fill:#FFD200;" cx="255.676" cy="208.003" r="112"/>
        </g>
        <g>
          <path style="fill:#FF9600;" d="M176.821,128.497c-20.46,20.293-33.145,48.412-33.145,79.506c0,61.856,50.144,112,112,112
            c31.094,0,59.212-12.686,79.506-33.146L176.821,128.497z"/>
        </g>
        <g>
          <circle style="fill:#FFFFFF;" cx="296.001" cy="167.677" r="32"/>
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
// https://www.svgrepo.com/svg/154013/medal
export default {
  props: {
    'width': {
      type : [Number, String],
      default : 30
    },
    'height': {
      type : [Number, String],
      default : 30
    }
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
}
</script>
